<div>
    <!-- Cuentas propias -->
    <div class="col-12">
        <div class="row mb-4">
            <!-- Fecha inicio -->
            <div class="col-sm-6">
              <label for="startDate" class="form-label">Año</label>
              <!-- Año -->
                <select class="form-select" [(ngModel)]="selectedYear" (change)="updateMonths()">
                    <option *ngFor="let y of years" [value]="y">
                    {{ y }}
                    </option>
                </select>
            </div>
    
            <!-- Fecha fin -->
            <div class="col-sm-6">
              <label for="endDate" class="form-label">Mes</label>
              <select class="form-select" [(ngModel)]="selectedMonth">
                    <option *ngFor="let m of months" [value]="m.value">
                    {{ m.label }}
                    </option>
                </select>
            </div>
    
            <div class="col-sm-6">
                <label for="ownAccount" class="form-label fw-semibold">Cuenta bancaria propia</label>
                <select class="form-select" [(ngModel)]="selectedOwnAccount">
                    <option
                    *ngFor="let account of filterAccounts"
                    [ngValue]="account.accountNumber">
                    {{ account.alias }} - {{ account.accountNumber }}
                    </option>
                </select>
            </div>
            <div class="col-sm-6 d-flex align-items-end justify-content-end">
              <button class="btn btn-primary w-100" (click)="openConfirmModal()" [disabled]="!selectedOwnAccount || loading">
                <i class="fa fa-search" *ngIf="!loading"></i>
                <span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loading"></span> Buscar
              </button>
            </div>
        </div>
</div>
<app-modal-dialog
  [title]="'Confirmar Consulta de Estado de Cuenta'"
  [show]="confirmModalVisible"
  [showHeader]="true"
  [showFooter]="false"
  size="md"
  position="center"
  (closed)="onCancelAccountStatus()"
>
  <div modal-body>
    <div class="alert alert-warning d-flex align-items-center">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <span>Revisa cuidadosamente los datos antes de consultar el estado de cuenta.</span>
    </div>

    <p>
      <strong>Año:</strong>
      <span class="text-muted">{{ accountStatusPreview?.year }}</span>
    </p>

    <p>
      <strong>Mes:</strong>
      <span class="text-muted">{{ accountStatusPreview?.month }}</span>
    </p>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Cuenta</h6>

        <div *ngIf="accountStatusPreview?.account">
          <div>
            {{ accountStatusPreview.account.accountNumber }} - {{ accountStatusPreview.account.alias }}
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm mb-2">
      <div class="card-body p-2">
        <h6 class="fw-bold text-primary mb-1">Código</h6>

        <div *ngIf="!showInputCode">
          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Solicitar Código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>

        <div *ngIf="showInputCode">
          <div class="input-group">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="code2fa">

            <button class="btn btn-success" (click)="pastClipboard()">
              <i class="fa fa-clipboard"></i>
            </button>
          </div>

          <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
            Volver a solicitar código
            <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="card-body p-3">
        <div class="col">
          <button class="btn btn-secondary btn-block" (click)="onCancelAccountStatus()">
            Cancelar
          </button>

          <button
            class="btn btn-primary btn-block"
            (click)="onConfirmAccountStatus()"
            *ngIf="showInputCode && code2fa"
            [disabled]="loading">
            Finalizar
          </button>
        </div>
      </div>
    </div>
  </div>
</app-modal-dialog>